module.exports = __webpack_public_path__ + "components/country-flag/static/bh-c4d41136b97b0eccd90dddd41625d64c.svg";